module.exports = __webpack_public_path__ + "media/coffee-preferences/brew_method_espresso-16a2b4cf.png";